var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoSideBarMenuPhysicalRes({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "xsbh3o13ea"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.275000 0 0 0 0 0.327941 0 0 0 0 0.500000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16 -11)",
    filter: "url(#xsbh3o13ea)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.5 17)",
    stroke: "#FFF"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 14,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9 3.5h3M9 8.5h3M9 13.5h3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 2.5,
    width: 1,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 7.5,
    width: 1,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 12.5,
    width: 1,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M.5 6h14M.5 11h14"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSideBarMenuPhysicalRes);
export default __webpack_public_path__ + "static/media/ico-side-bar-menu-physical-res.a0b9026f4f7ec8927334ed378c3f1639.svg";
export { ForwardRef as ReactComponent };